/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RadiologyReport from './radiology-report';
import RadiologyReportDetail from './radiology-report-detail';
import RadiologyReportUpdate from './radiology-report-update';
import RadiologyReportDeleteDialog from './radiology-report-delete-dialog';

const RadiologyReportRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RadiologyReport />} />
    <Route path="new" element={<RadiologyReportUpdate />} />
    <Route path=":id">
      <Route index element={<RadiologyReportDetail />} />
      <Route path="edit" element={<RadiologyReportUpdate />} />
      <Route path="delete" element={<RadiologyReportDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RadiologyReportRoutes;
